"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21 21V3H3v18zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), 'InsertPhotoSharp');